import { useLogon } from '@core/Utils/hooks'
import React from 'react'
import { useLocation } from 'react-router'

type InterceptTypes =
  | 'deposit'
  | 'racing-bet'
  | 'racing-bonus'
  | 'racing-special'
  | 'sports-bet'
  | 'sports-bonus'

declare global {
  interface Window {
    _qualtrics?: {
      intercept?: string
    }
    QSI?: {
      API: {
        run: () => void
      }
      config: {
        externalReference?: number
      }
    }
  }
}

export const setQualtricsIntercept = (intercept: InterceptTypes | undefined) => {
  window._qualtrics = window._qualtrics || {}
  window._qualtrics.intercept = intercept
}

export const useQualtricsInteceptor = () => {
  const { accountNumber } = useLogon()
  const location = useLocation()

  React.useEffect(() => {
    if (!accountNumber) {
      setQualtricsIntercept(undefined)
      if (window.QSI) {
        window.QSI.config.externalReference = undefined
      }
    }
  }, [accountNumber])

  React.useEffect(() => {
    // Only trigger intercept when:
    // - Qualtric has loaded
    // - on home page
    // - logged in
    // - an intercept is actually set
    if (!window.QSI || location.pathname != '/' || !accountNumber || !window._qualtrics?.intercept)
      return

    setTimeout(() => {
      if (window.QSI) {
        window.QSI.config.externalReference = accountNumber
        window.QSI.API.run()
        setQualtricsIntercept(undefined)
      }
    }, 1000)
  }, [location, accountNumber])
}
